module.exports = __webpack_public_path__ + "img/epicTravelers.d3dba08d.png";